
<template>
  <v-row align="center" justify="end" class="px-3">
    <v-chip v-if="with_dialog" @click="dialog_set_date = true" style="border-radius: 8px;" >
      <v-avatar left>
        <v-icon>mdi-calendar</v-icon>
      </v-avatar>
      {{dateString}}
    </v-chip>
    
    <v-dialog v-model="dialog_set_date" v-if="with_dialog" max-width="500px" transition="dialog-transition" >
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Pesquisa por data</div>
        </v-card-title>
        <v-card-text>
          <v-dialog ref="dialog_date_filter" :return-value.sync="date_range" width="290px" >
            <template v-slot:activator="{ on }">
              <v-text-field :value="comp_date_range" clearable @click:clear="date_range=[]; clearDateFilter()" clear-icon="mdi-close mdi-18px" :label="date_range.length==1?'A partir de':date_range.length==2?'Intervalo':'Filtrar'" prepend-icon="event" readonly v-on="on" color="secondary"></v-text-field>
            </template>
            <v-date-picker v-model="date_range" :type="k" scrollable locale="pt-BR" :range="k=='date'" color="secondary">
              <v-spacer></v-spacer>
              <!-- <v-btn text color="primary" @click="modal = false">Cancel</v-btn> -->
              <v-btn text color="secondary" @click="$refs.dialog_date_filter.save(date_range)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
          
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text color="error" @click="dialog_set_date = false">Cancelar</v-btn>
          <v-btn :disabled="date_range.length==0" color="secondary" @click="setDatesAndFetch()"><v-icon left>mdi-magnify</v-icon>OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-menu v-if="with_menu" ref="menu" v-model="dialog_set_date" :close-on-content-click="false" :return-value.sync="date_range" transition="scale-transition" >
      <template v-slot:activator="{ on, attrs }">
        <v-chip v-on="on" style="border-radius: 8px;" >
          <v-avatar left>
            <v-icon>mdi-calendar</v-icon>
          </v-avatar>
          {{dateString}}
        </v-chip>
      </template>
      <v-date-picker v-model="date_range" :type="k" scrollable locale="pt-BR" :range="k=='date'" color="secondary" >
        <v-btn text small color="error" @click="dialog_set_date = false" >
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn text small color="secondary" @click="$refs.menu.save(date_range); setDatesAndFetch() " >
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>

    <!-- <v-btn :disabled="date_range.length==0" small text fab dark color="white" @click="fetchFilteredItems()"><v-icon>mdi-magnify</v-icon></v-btn> -->
  </v-row>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  props: {
    kind:{
      type: String,
      default: 'date',
    },
    indexFilter: {
      type: Function,
    },
    with_emit: {
      type: Boolean,
      default: () => false
    },
    with_dialog: {
      type: Boolean,
      default: () => true
    },
    with_menu: {
      type: Boolean,
      default: () => false
    },
    filters: {
      type: Object, 
      default: () => {}
    }
  },
  data() {
    return {
      date_range:[],

      k: null,

      dialog_set_date: false,
      new_date_filter: {},
    }
  },
  created() {
    this.k = this.solution_is_resolve? 'month' : this.kind
    this.setKind(this.k)
    if (this.k == 'date'){
      this. date_range = []
    } else {
      this.date_range = new Date().toISOString().substring(0,7)
    }

    if (this.dateRange){
      // console.log('has dateRange');
      this.date_range = this.dateRange
    }
  },
  methods: {
    fetchFilteredItems(){
      // console.log(typeof(this.date_range), this.date_range);
      
      if (Array.isArray(this.date_range) && this.date_range.length>1){
        let fd = this.$moment(this.date_range[1]).add(1, 'days').format('YYYY-MM-DD')
        this.date_range[1] = fd
        // console.log(' 2 datas ');

           // auto-comment// console.log(this.date_range);
        if (this.indexFilter)
          this.indexFilter({...this.filters, ...this.dateStartEnd, solutionID: this.solutionID})
          // this.indexFilter({start_date: this.date_range[0], end_date: this.date_range[1], solutionID: this.solutionID})
        else if (this.with_emit){
          this.$emit('filterDate', this.dateStartEnd)
        } else 
          this.setDateFilter({start_date: this.date_range[0], end_date: this.date_range[1]})
      }else if (typeof(this.date_range) == 'string' && this.date_range.length>1){
        // works for month searches, like on solution resolve or covid
        // console.log(' 1 data ');
        
        let start_date = this.$moment(this.date_range).startOf('month').format('YYYY-MM-DD')
        let end_date = this.$moment(this.date_range).endOf('month').add(1,'days').format('YYYY-MM-DD')
        if (this.indexFilter){
          this.indexFilter({...this.filters, ...this.dateStartEnd, solutionID: this.solutionID})
        }
        this.$emit('filterDate', {...this.dateStartEnd})
        // this.$emit('filterDate', {start_date, end_date})
      }
      
    },
    formatDate(d){
         // auto-comment// console.log({d});
      
      if (!d) return null

      const [year, month, day] = d.substring(0,11).split('-')
      let date = day? `${day}/${month}/${year}` : `${month}/${year}`
      return date
    },
    setDatesAndFetch(){
      this.setDate(this.date_range)
      this.fetchFilteredItems()
      this.dialog_set_date = false
    },
    ...mapActions({
      setDateFilter: 'Dashboard/setDateFilter',
      clearDateFilter: 'Dashboard/clearDateFilter',

      setDate: 'DateFilter/setDate',
      setKind: 'DateFilter/setKind',

      // function: 'Module/action'
    })
  },
  computed: {
    comp_date_range(){
         // auto-comment// console.log('there');
         // auto-comment// console.log(this.date_range && Array.isArray(this.date_range))
         // auto-comment// console.log(this.date_range)
         // auto-comment// console.log(typeof(this.date_range)=='object')
      if (this.date_range && Array.isArray(this.date_range)){
        
        let d_pt = this.date_range.sort().map(o=>this.formatDate(o))
        d_pt = d_pt.join(' ~ ')
        return d_pt || this.dateString
      } else if (this.date_range.length>0 && typeof(this.date_range)=='string') {
           // auto-comment// console.log('here');
        
        return this.formatDate(this.date_range)
      }
    },
    active_solution() {
      if (this.solutionID && this.allSolutions) {
        return this.allSolutions.find((o) => o.id == Number(this.solutionID));
      }
    },
    solution_is_resolve() {
      if (this.active_solution) {
        return ["resolve", "corona"].includes(
          this.active_solution.proposal_name.toLowerCase()
        );
      }
    },
    ...mapState({
      solutionID: state => state.Solution.solutionID,
      allSolutions: state => state.Solution.allSolutions,

      date_filter: state => state.DateFilter.date_filter,
      // data: state=> state.Module.state_var
    }),
    ...mapGetters({
      dateRange: 'DateFilter/getDateRange',
      dateString: 'DateFilter/getDateString',
      dateStartEnd: 'DateFilter/getStartEndDate',
    })
  },
  watch: {
    dialog_set_date(nv,ov) {
      if (nv){
        this.new_date_filter = {...this.date_filter}
      } else if (nv == false){
        this.new_date_filter = {}
      }
    },
    filters(nv,ov) {
      if (nv){
        this.setDatesAndFetch()
      } else if (nv == false){
    
      }
    }
  },
}
</script>

<style scoped>

</style>